import CNETButton, { Props as CNETButtonType } from '../../components/01_atoms/Button';

import styles from './index.module.scss';

const Button = (props: CNETButtonType) => {
  return <CNETButton {...props} className={`${styles['gifts-button']} ${props.className || ''}`} />;
};

export default Button;
